
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Fourtifivebusonreninpune() {



  const cardData =
  {
    keyword: '  45 Seater Bus on Rent in Pune',
    heading: 'Vaishnavi Travels:  45 Seater Bus on Rent in Pune',
    headingDescription: 'Vaishnavi Travels provides reliable and budget-friendly 45 Seater Bus on Rent in Pune, perfect for managing large group travel for weddings, school trips, corporate events, and long outstation tours. Our buses are spacious, air-conditioned, and well-maintained with comfortable seating and ample luggage space to make every journey smooth and enjoyable. With professional and experienced drivers, timely pickups, and flexible booking options, we ensure a stress-free travel experience for all occasions. Whether it’s a religious yatra, family function, business tour, or holiday getaway, Vaishnavi Travels guarantees safe, comfortable, and convenient 45 seater bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],

"services": [
{
"name": "45 Seater Bus Hire Pune",
"description": "Reliable 45 seater bus hire service in Pune catering to large groups who need spacious, comfortable, and safe transportation. Our fleet includes both AC and non-AC buses, ideal for weddings, corporate events, family tours, and school trips. Each bus is well-maintained with modern amenities, ensuring a smooth journey with professional drivers experienced in local and long-distance routes."
},
{
"name": "Large Group Bus Rental Pune",
"description": "Specialized rental services for large groups requiring 45 seater buses in Pune. Perfect for big families, corporate outings, or event transportation, these buses offer ample legroom, luggage space, and comfortable seating arrangements. With flexible rental durations and on-time pickups, you get efficient transport solutions that match your event’s specific needs."
},
{
"name": "Wedding 45 Seater Bus Pune",
"description": "Elegant and spacious 45 seater buses for weddings in Pune, available in both AC and non-AC options. These buses are ideal for transporting wedding guests comfortably between venues, hotels, and event locations. Decorated on request, with courteous drivers who prioritize punctuality and safety, making your special day stress-free and memorable."
},
{
"name": "45 Seater Tourist Bus Hire",
"description": "Comfortable 45 seater tourist bus rentals in Pune designed for sightseeing and leisure trips. Equipped with large windows, air conditioning (optional), and reclining seats, these buses provide a pleasant travel experience for groups exploring local attractions, hill stations, and religious tours. Customizable itineraries and experienced drivers ensure a hassle-free tour."
},
{
"name": "Office Event Bus 45 Seater",
"description": "Efficient 45 seater bus hire for corporate office events and team outings in Pune. These buses provide a comfortable and professional travel environment, equipped with AC and spacious seating. Whether for conferences, client meetings, or company retreats, our buses come with flexible booking options and punctual driver services to accommodate your schedule."
},
{
"name": "AC 45 Seater Bus Pune",
"description": "Premium air-conditioned 45 seater buses available for hire in Pune, ensuring cool and comfortable journeys throughout the year. Ideal for long-distance travel, weddings, and corporate events, these buses offer modern amenities like climate control, entertainment systems, and ergonomic seating. Experienced drivers prioritize safety and timely arrivals."
},
{
"name": "Non AC 45 Seater Bus Rental",
"description": "Cost-effective non-AC 45 seater bus rental services in Pune suited for short-distance travel, budget events, and local tours. These buses maintain a high standard of cleanliness and safety, providing reliable transportation for school trips, family outings, and social functions without compromising comfort."
},
{
"name": "School Trip 45 Seater Bus Pune",
"description": "Safe and reliable 45 seater bus rentals tailored for school trips in Pune. Our buses include child safety features, ample seating, and well-trained drivers focused on student safety and punctuality. Suitable for educational excursions, field trips, and group activities, ensuring peace of mind for schools and parents alike."
},
{
"name": "Outstation 45 Seater Bus Hire",
"description": "Trusted 45 seater bus hire for outstation travel from Pune, perfect for group tours, weddings, corporate retreats, and long-distance trips. These buses include driver and toll charges in the package and offer comfortable seating with optional AC. Our drivers are skilled in highway navigation, ensuring safe and timely journeys."
},
{
"name": "Family Tour 45 Seater Bus",
"description": "Spacious 45 seater buses for family tours in Pune, providing a comfortable and enjoyable travel experience. These buses accommodate large families and groups, with features like air conditioning, reclining seats, and large luggage compartments. Ideal for weekend getaways, religious trips, and leisure travel."
},
{
"name": "45 Seater Bus with Driver Pune",
"description": "Comprehensive 45 seater bus rental packages in Pune including professional drivers trained for safe and courteous service. Drivers are knowledgeable about local routes and long-distance highways, ensuring timely arrivals and smooth rides for all types of group travel such as weddings, corporate events, and tours."
},
{
"name": "Long Distance 45 Seater Bus",
"description": "Reliable long-distance 45 seater bus rentals in Pune, equipped for extended journeys with comfort and safety. Suitable for interstate travel, group vacations, and corporate tours, these buses offer ample space, optional air conditioning, and experienced drivers who prioritize customer satisfaction and timely arrivals."
},
{
"name": "Book 45 Seater Bus Online Pune",
"description": "Convenient online booking platform for 45 seater bus rentals in Pune, offering instant confirmations, transparent pricing, and customizable add-ons such as decorations, refreshments, and route planning. Book your bus anytime from anywhere with easy payment options and dedicated customer support for hassle-free travel arrangements."
}
],
"tableData": [
["45 Seater Bus Hire Pune", "Large Group Bus Rental Pune"],
["Wedding 45 Seater Bus Pune", "45 Seater Tourist Bus Hire"],
["Office Event Bus 45 Seater", "AC 45 Seater Bus Pune"],
["Non AC 45 Seater Bus Rental", "School Trip 45 Seater Bus Pune"],
["Outstation 45 Seater Bus Hire", "Family Tour 45 Seater Bus"],
["45 Seater Bus with Driver Pune", "Long Distance 45 Seater Bus"],
["Book 45 Seater Bus Online Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable 45 Seater Bus on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and budget-friendly 45 seater bus rentals in Pune, perfect for large groups and special occasions."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating for Large Groups",
    "WhyChoosedescription": "Our 45 seater buses provide ample legroom and comfortable seating, ensuring a smooth and pleasant journey for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and cleaned thoroughly to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Match Your Schedule",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel itinerary and group size."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service, with expert knowledge of Pune and nearby routes."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Weddings, and Group Outings",
    "WhyChoosedescription": "Perfect for corporate gatherings, wedding transportation, sightseeing tours, and large group travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Vaishnavi Travels offers round-the-clock customer support to assist you with bookings and travel inquiries."
  }
]



































  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide 45 seater buses on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels offers 45 seater buses for rent in Pune. These are great for large group travel such as weddings, corporate events, pilgrimages, or long‑distance tours. We maintain high standards of cleanliness, safety, and comfort so your group travels smoothly.',
    },
    {
      question: 'Do you have both AC and Non‑AC 45 seater options?',
      answer: 'Absolutely. We have both AC and non‑AC 45 seater buses. AC buses offer more comfort, especially on longer or hotter journeys; non‑AC options are more economical while still being safe and well‑maintained.',
    },
    {
      question: 'What are typical rates for renting a 45 seater bus in Pune?',
      answer: 'For outstation travel, rates usually start from around **₹ 19,000 to ₹ 24,000+** (AC) depending on distance, route, permissions, tolls, driver allowance, etc. For local city packages (4‑8 hrs), rates can be around **₹ 8,000 to ₹ 12,000+** depending on hours and KM. We’ll give you all cost components in the quote.',
    },
    {
      question: 'What amenities do your 45 seater buses have?',
      answer: 'These buses are equipped with comfortable seating, overhead luggage space, music / audio‑video systems, proper ventilation, and for AC models, climate control. We also ensure drivers are experienced and buses are safety‑checked regularly.',
    },
    {
      question: 'Are there extra charges beyond the base fare?',
      answer: 'Yes. Extras like tolls, parking, extra kilometres/hours beyond the booked package, night halts, driver allowance (if overnight), permits (if required), etc., are additional. We include these in the estimate so there are no hidden surprises.',
    },
    {
      question: 'How much advance booking is recommended for a 45 seater bus?',
      answer: 'For local trips, booking 2‑4 days ahead is often enough. But for outstation travel, weddings, peak seasons, or if you want AC variants, booking 1‑2 weeks in advance is safer to ensure availability and better pricing.',
    },
    {
      question: 'Can pickup/drop‑off from multiple locations be arranged?',
      answer: 'Yes, we can arrange multiple pickup and drop‑off points within Pune or its outskirts. We plan routes to minimize extra distance and time, and any extra cost involved is included in your final cost estimate.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Ganesh Kulkarni",
    position: "Corporate Events Manager",
    feedback:
      "We hired a 45 seater AC bus from Vaishnavi Travels for our conference attendees. The bus was spacious, AC worked perfectly, and the driver was punctual. Everyone was comfortable and impressed with the service. The clarity in billing and absence of hidden charges made the experience really good.",
    rating: 5,
  },
  {
    name: "Ms. Nisha Rao",
    position: "Wedding Coordinator",
    feedback:
      "For a large wedding guest list, we needed a 45 seater non‑AC bus for local transfers. Vaishnavi Travels provided one that had ample space for guests and luggage, and the driver handled the multiple stops gracefully. The journey was safe, clean, and comfortable for everyone. Booking was smooth and the support helpful throughout.",
    rating: 5,
    style: "style-2",
  },
];

















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "45 Seater Bus on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/45-seater-bus-pune.jpg",
  "description": "Rent a 45 seater bus in Pune with Vaishnavi Travels for weddings, corporate events, school trips, and family tours. Choose from AC and Non AC options for a comfortable and reliable group travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.83",
    "ratingCount": "2025"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/45-seater-bus-on-rent-in-pune"
  }
};



  return (
    <div>


<Helmet>
  <title>45 Seater Bus on Rent in Pune | AC & Non AC Large Group Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent a 45 seater bus in Pune with Vaishnavi Travels for weddings, corporate events, school trips, and family tours. Choose from AC and Non AC options for a comfortable and reliable group travel experience."
  />
  <meta
    name="keywords"
    content="45 Seater Bus Hire Pune, Large Group Bus Rental Pune, Wedding 45 Seater Bus Pune, 45 Seater Tourist Bus Hire, Office Event Bus 45 Seater, AC 45 Seater Bus Pune, Non AC 45 Seater Bus Rental, School Trip 45 Seater Bus Pune, Outstation 45 Seater Bus Hire, Family Tour 45 Seater Bus, 45 Seater Bus with Driver Pune, Long Distance 45 Seater Bus, Book 45 Seater Bus Online Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourtifivebusonreninpune;